export function post(url, body) {
  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(body),
  }).then(res => res.text())
}



// WEBPACK FOOTER //
// ./src/common/httpUtil.js